<template>
  <wrapper>
    <template slot="navigation">
      <menu-point icon="columns" to="dashboard">Dashboard</menu-point>
      <menu-point icon="calendar" to="events">Veranstaltungen</menu-point>
      <!--<menu-point icon="calendar" to="events">Übersichtsseiten</menu-point>-->
      <menu-point icon="shopping-bag" to="orders">Bestellungen</menu-point>
      <menu-point icon="file-invoice" to="settlement.settlements">Abrechnungen</menu-point>
      <menu-point icon="cog" to="account.details">Einstellungen</menu-point>
    </template>

    <template slot="page">
      <router-view />
    </template>
  </wrapper>
</template>

<script>
import { MenuPoint } from "@/components/Wrapper";
import Wrapper from "@/components/Wrapper";

export default {
  components: {
    MenuPoint,
    Wrapper
  }
};
</script>
